export const PENDING_FILES_QUERY_KEY = 'pending-files'